import { Component, OnInit, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { InterviewStepService } from '@app/services/interviewStep.service';
import { InterviewStepMapping } from '@app/model/interviewStepMapping';
import { InterviewStep } from '@app/model/interviewStep';
import { MessageService, SelectItem } from 'primeng/api';
import { Messages } from '@app/constants/constant';
import { QueryOptions } from '@app/model/query-options';
import { InterviewStepStatusService } from '@app/services/interviewstep-status.service';
import { InterviewFeedback } from '@app/model/interviewFeedback';
import { FeedbackService } from '@app/services/feedback.service';
import { debug } from 'util';
import { ViewScheduledInterviewService } from '@app/services/viewScheduledInterview.service';
import { Router } from '@angular/router';
import { TypeScriptEmitter } from '@angular/compiler';

@Component({
  selector: 'app-feedback-popup',
  templateUrl: './feedback-popup.component.html',
  styleUrls: ['./feedback-popup.component.css']
})
export class FeedbackPopupComponent implements OnInit {
  pageSize: number = 100;
  first: number = 0;
  @Input() display: boolean=false;
  @Input() interviewData:any;
  @Input() interviewStepData:any;

  @Output() displayFunction = new EventEmitter<boolean>();
  @ViewChild('feedbackForm', { static: false }) public feedbackForm: NgForm;
  feedback:any={
    interviewer:'',
    stepstatus:'',
    comments:'',
    candidatestatus:''
  }
  interviewerName: SelectItem[];
  interviewStepMapping :any;
  interviewStatus: any;
  candidateStatus: any;
  disable : boolean=false;
  interviewStepDetails:any;
  stepStaus: SelectItem[];
  jobId: any;
  feedStatus:any;
  interviewstatusId :any;

 
  constructor(private _interviewStepService :InterviewStepService,
    private _toastService: MessageService,
    private _interviewStepStatusService : InterviewStepStatusService,
    private _feedbackService : FeedbackService,
    private _viewScheduledInterviewService: ViewScheduledInterviewService,
    private _router : Router) { }
//

ngOnInit() {
  this.feedback.comment=this.interviewStepData.notes;
  this.feedback.stepstatus=this.interviewStepData.interviewStatusObj//ShOw sElEcTeD InTeRvIeW StEp sTaTuS
  this.updateCandidateStatus(this.feedback.stepstatus);
  this.feedback.candidatestatus=this.interviewData.status ;//show selected candidate status
    var sortParams= this.queryParams("name");
    this.jobId= this.interviewStepData.jobId;
    var includeCancel =this.feedback.stepstatus.id==Messages.interviewStepStatusIds.Re_Scheduled ||
     this.feedback.stepstatus.id==Messages.interviewStepStatusIds.Scheduled ? true:false;
    this._interviewStepStatusService.list(sortParams,Messages.endpoint.filteredInterviewStepStatus+includeCancel).subscribe(res => {
    this.interviewStatus= res;
  });
    this.interviewerName = [
      {label:this.interviewStepData.interviewer, value:this.interviewStepData.interviewerObj.id}];
    this.disable=this.interviewStepData.islast;
  }


  updateCandidateStatus(selectedStepStatus){
   var endpointCandidateStatus="interview-status-mapping/"+selectedStepStatus.id
    this._interviewStepStatusService.list(this.queryParams("interviewStatus.name"),endpointCandidateStatus).subscribe(res => {
      this.candidateStatus= res.filter(item=>item.id!= Messages.interviewStatusIds.scheduled);
    });
  }

  queryParams(sortfieldName){
    const queryParams = new Object();
    queryParams['sortParam'] = { sortField: sortfieldName, sortOrder: 1 };
    queryParams['pageParam'] = {
    page:
        this.first / this.pageSize > 1
        ? this.first / this.pageSize + 1
         : this.first / this.pageSize,
      size: this.pageSize
    };
    const dropDownSortingQueryOptions = new QueryOptions(queryParams);
    dropDownSortingQueryOptions.toQueryMap();
    return dropDownSortingQueryOptions;
}

  showDialog(bool: boolean) {
    this.displayFunction.emit(bool);
  }

  updateInterviewStepMapping(feedbackForm){
     let intfeedback = new InterviewFeedback();
     intfeedback.interviewId= this.interviewStepData.interviewId;
     intfeedback.interviewStepMappingId= this.interviewStepData.id;
     intfeedback.interviewerId= this.interviewStepData.interviewerObj.id;
     intfeedback.interviewStatus= this.feedbackForm.value.candidatestatus?this.feedbackForm.value.candidatestatus.id :this.interviewStepData.interviewStatusObj.id ;
     intfeedback.interviewStepStatus= this.feedbackForm.value.stepstatus?this.feedbackForm.value.stepstatus.id :'' ;
     intfeedback.feedback= this.feedbackForm.value.comments ? this.feedbackForm.value.comments : '';
     this._feedbackService.create(intfeedback,'interview/step-feedback').subscribe(res=>{
        this.showfeedbackToast();
        this.feedbackForm.reset();   
        this.showDialog(false);
       this._router.navigateByUrl('/interview-schedule-list', { skipLocationChange: true }).then(() => {
              this._router.navigate(['view-scheduled-interview-list/'+ this.jobId ])

    }); 
     },
     (err)=>{
       this._toastService.add({
         severity:'error',
         summary:Messages.feedbackError,
         detail: Messages.tryAgain
       });
     })
  }

  showfeedbackToast = function () {
    this._toastService.add({ severity: 'success', summary: Messages.feedbackSucess, detail: '' });}

}
